export default __webpack_public_path__ + "static/media/FitzroyPlan.c5bcd4fd.jpg";